import { Component, input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProductDto } from "@malirang/api-client";
import { ColumnDefinition } from "@malirang/front-share";
import { ProductBadgesComponent } from "libs/app-share/src/lib/store/product-badges/product-badges.component";

@Component({
    selector: "app-product-title",
    templateUrl: "./product-title.component.html",
    styleUrls: ["./product-title.component.css"],
    imports: [CommonModule, ProductBadgesComponent],
})
export class ProductTitleComponent {
    row = input<ProductDto>();
    column = input<ColumnDefinition>();
}
